import {
    Children,
    type FC
} from "react";
import type IAccordionContentProps from "./type";
import type {
    AccordionContentRegionPropsType
} from "./type";
import stylesheet, {
    useStyles
} from "./stylesheet";
import {
    NCoreUIKitTheme
} from "../../../../core/hooks";
import type {
    AccordionItemPartContentProps
} from "../../type";
import {
    withAccordionItemContext
} from "../../context";
import {
    getAccordionMeasures
} from "../../stylesheet";
import CollapseRegion from "../../../collapsible/internal/collapseRegion";
import Text from "../../../text";

const AccordionContentContent: FC<AccordionItemPartContentProps<IAccordionContentProps>> = ({
    customTheme: customThemeProp,
    contentContainerStyle,
    isKeepMounted = false,
    isInset = false,
    role: roleProp,
    itemContext,
    children,
    context,
    style,
    ...props
}) => {
    const customTheme = customThemeProp ?? context.customTheme;

    const {
        controlPaddings,
        controlHeights,
        shapeConfigs,
        typography,
        iconSizes,
        spaces
    } = NCoreUIKitTheme.useContext(customTheme);

    const currentMeasures = getAccordionMeasures({
        variant: context.variant,
        size: context.size,
        controlPaddings,
        controlHeights,
        shapeConfigs,
        typography,
        iconSizes,
        spaces
    });

    const {
        content: contentDynamicStyle
    } = useStyles({
        currentMeasures,
        isInset,
        spaces
    });

    const regionProps: AccordionContentRegionPropsType = context.isRegionEnabled ? {
        "aria-labelledby": itemContext.triggerID,
        role: roleProp ?? "region"
    } : {
        role: roleProp
    };

    const renderChildren = () => {
        return Children.map(children, (child) => {
            if(typeof child !== "string" && typeof child !== "number") {
                return child;
            }

            return <Text
                variant={currentMeasures.valueVariant}
                customTheme={customTheme}
                color="mid"
            >
                {child}
            </Text>;
        });
    };

    return <CollapseRegion
        {...props}
        {...regionProps}
        isKeepMounted={isKeepMounted}
        isOpen={itemContext.isOpen}
        contentStyle={[
            contentContainerStyle,
            stylesheet.content,
            contentDynamicStyle
        ]}
        id={itemContext.contentID}
        customTheme={customTheme}
        style={style}
    >
        {renderChildren()}
    </CollapseRegion>;
};
export default withAccordionItemContext("content", AccordionContentContent);
